import styled from 'styled-components'

const ListItemIcon = styled.div`
  display: flex;
  min-width: 30px;
  margin: 0 10px;
`

export { ListItemIcon }
